import { isEqual } from 'lodash';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { ComponentStylingInterface, PresentationComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

const PresentationStyling = ({ component, onChange }: ComponentStylingInterface<PresentationComponentInterface>) => {
  const [currComponent, setCurrComponent] = useState(component);
  const { t } = useTranslation();
  useEffect(() => {
    setCurrComponent(component);
  }, [component]);

  return (
    <PageBuilderSettingsTable
      sections={[
        {
          settings: [
            {
              type: 'color',
              label: t('pagebuilder:presentation-text-color'),
              path: 'customStyling.presentationTextColor',
            },
          ],
        },
      ]}
      onChange={onChange}
      component={component}
      showTitleAndDescription={false}
    />
  );
};
export default React.memo(PresentationStyling, (prevprop, newprop) => isEqual(prevprop, newprop));
